export default `/* Ids Step Chart Component */
:host {
  width: 100%;
}

:host([disabled]) .ids-step-chart .step-chart-container .step {
  background-color: var(--ids-step-chart-step-disabled-color);
}

.ids-step-chart {
  contain: content;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin: var(--ids-step-chart-margin);
}
.ids-step-chart .step-label-container {
  margin-block-end: var(--ids-step-chart-inner-margin);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1 1 auto;
}
.ids-step-chart .step-label-container .secondary-label {
  display: flex;
  flex-direction: row;
}
.ids-step-chart .step-label-container .secondary-label .completed-label {
  margin-inline-end: var(--ids-step-chart-inner-margin);
}
.ids-step-chart .step-label-container .secondary-label .icon {
  margin-inline-start: var(--ids-step-chart-inner-margin);
}
.ids-step-chart .step-chart-container {
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
}
.ids-step-chart .step-chart-container .step {
  background-color: var(--ids-step-chart-color-background-default);
  margin: calc(var(--ids-step-chart-inner-margin) - 3px);
  height: var(--ids-step-chart-height);
  box-sizing: content-box;
  border: 1px;
  flex: 1 1 auto;
}
.ids-step-chart .step-chart-container .step.complete {
  background-color: var(--ids-step-chart-color-background-complete);
}
.ids-step-chart .step-chart-container .step.in-progress {
  background-color: var(--ids-step-chart-color-background-progress);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
